import { render } from "./BottomTabBarItemView.vue?vue&type=template&id=7aa83ef6&scoped=true"
import script from "./BottomTabBarItemView.vue?vue&type=script&lang=js"
export * from "./BottomTabBarItemView.vue?vue&type=script&lang=js"

import "./BottomTabBarItemView.vue?vue&type=style&index=0&id=7aa83ef6&scoped=true&lang=less"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7aa83ef6"]])

export default __exports__